import store from './store'
import router from './router'
// import Firebase from 'firebase'
import Firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/database'
// import 'firebase/compat/functions'
import 'firebase/compat/storage'
import 'firebase/compat/analytics'
import 'firebase/compat/firestore'

const config = JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG);
let redirectUrl;

if(process.env.NODE_ENV === "production") {
  redirectUrl = 'https://app.healthassuranceplan.com/log-in';
}
// staging has both NODE_ENV production and Vue_APP_ENV, so this overwrites and must come 2nd
if(process.env.VUE_APP_ENV === "staging") {
  redirectUrl = 'https://health-assurance-staging.firebaseapp.com/log-in';
}
if(process.env.NODE_ENV === "development") {
  redirectUrl = "http://localhost:8080/log-in"
}


// via https://medium.com/@MichalBujalski/reactive-firebase-auth-with-vue-92577ab78ff6
export default {
  install: (Vue) => {
    //  store as global properties for easy access
    Vue.firebase = Firebase.initializeApp(config)
    Vue.auth = Vue.firebase.auth()
    Vue.db = Vue.firebase.database()
    Vue.storage = Vue.firebase.storage()
    Vue.analytics = Vue.firebase.analytics()
    Vue.firestore = Vue.firebase.firestore()
    Vue.phoneAuthProvider = new Firebase.auth.PhoneAuthProvider();
    const redirectSettings = {
      url: redirectUrl
    }
    Vue.prototype.$firebase = {
      logIn: async (email, password) => {
        return await Vue.auth.signInWithEmailAndPassword(email, password)
          .catch((err) => {
            // console.log(err);
            if (err.code == 'auth/multi-factor-auth-required') {
              console.log('start phone MFA process', err.resolver);
              // default to using phone for MFA, do not prompt user to choose method
              if(err.resolver && err.resolver.hints && err.resolver.hints.some(hint => hint.factorId == 'phone')) {
                return err;
              } else {
                console.error('no phone auth factor found');
                return err.code;
              }
            }
            return err;
          });
      },
      sendPhoneVerification: async (phoneInfoOptions, recaptchaVerifier) => {
        // Send SMS verification code.
        return Vue.phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier)
          .then((verificationId) => {
            // verificationId will be needed for sign-in completion.
            return verificationId;
          })
          .catch(err => {
            console.error('verifyPhoneNumber error',err.message);
            return err;
          });
      },
      signInWithPhoneCode: async (resolver, verificationId, verificationCode) => {
        var cred = Firebase.auth.PhoneAuthProvider.credential(verificationId, verificationCode);
        var multiFactorAssertion = Firebase.auth.PhoneMultiFactorGenerator.assertion(cred);
        // Complete sign-in. This will also trigger the Auth state listeners.
        return resolver.resolveSignIn(multiFactorAssertion)
          .then((userCredential) => {
            // console.log({userCredential});
            console.log('logged in with MFA successfully');
            return true;
          })
          .catch(err => {
            console.error('resolveSignIn error',err.message);
            return err;
          });
      },
      enrollPhoneMFA: async (user, verificationId, verificationCode) => {
        var cred = Firebase.auth.PhoneAuthProvider.credential(verificationId, verificationCode);
        var multiFactorAssertion = Firebase.auth.PhoneMultiFactorGenerator.assertion(cred);
        return user.multiFactor.enroll(multiFactorAssertion);
      },
      logOut: async () => {
        return await Vue.auth.signOut()
          .then(() => {
            store.dispatch('resetState');
            router.push('/log-in')
          })
          .catch((err) => {
            // console.log(err);
            return err
          });
      },
      signUp: async (email, password) => {
        let uid;
        return await Vue.auth.createUserWithEmailAndPassword(email, password)
          // after user created, send email verification
          .then(userCredential => {
            uid = userCredential.user.uid;
            // console.log("practice user saved",uid);
          })
          .then(() => {
            return Vue.db.ref(`user_props/${uid}/user_type`).set("practice");
          })
          .catch((err) => {
            // console.log(err);
            return err
          });
      },
      resetPassword: async (email) => {
        // console.log(resetPasswordRedirectSettings)
        return await Vue.auth.sendPasswordResetEmail(email, redirectSettings)
          .then(() => {
            return true
          })
          .catch((err) => {
            // console.log(err);
            return err
          });
      },
      verifyEmail: async () => {
        let user = Vue.auth.currentUser;
        return await user.sendEmailVerification(redirectSettings)
          .then(() => {
            // console.log("email sent");
            return true
          })
          .catch((err) => {
            // console.log(err);
            return false
          });
      },
      // patient-specific
      signUpGuarantor: async (email, password, practiceAccountId) => {
        // console.log('practiceAccountId',practiceAccountId);
        let uid;
        return await Vue.auth.createUserWithEmailAndPassword(email, password)
          // after user created, send email verification
          .then(userCredential => {
            uid = userCredential.user.uid;
            console.log("guarantor user saved",uid);
          })
          .then(() => {
            console.log('practiceAccountId',practiceAccountId);
            return Vue.db.ref(`user_props/${uid}/practice_account_id`).set(practiceAccountId);
          })
          .catch((err) => {
            console.log(err);
            return err
          });
      },
    }
    Vue.auth.onAuthStateChanged( async user => {
      store.dispatch('updateUser', user);
      if(user) {
        let userPropsRef = Vue.db.ref(`/user_props/${user.uid}`);
        store.dispatch('setUserPropsRef', userPropsRef);
        // track user in analytics
        Vue.analytics.setUserId(user.uid);
      }
    })
  }
}
